import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6dff6aed"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-dashboard" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divBanniere" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Qey Qey !")
], -1))
const _hoisted_3 = { class: "corpTableaudebord" }
const _hoisted_4 = { style: {"text-align":"left","color":"#2f4992","margin-left":"100px","margin-right":"100px"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = {
  key: 0,
  class: "titleLink"
}
const _hoisted_10 = {
  key: 1,
  class: "moduleDash"
}
const _hoisted_11 = {
  key: 0,
  class: "info"
}
const _hoisted_12 = {
  key: 1,
  class: "moduleContainer"
}
const _hoisted_13 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h1", null, "Qey Qey, " + _toDisplayString(_ctx.userName) + "!", 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t("dashboardMessage1")), 1),
        _hoisted_5,
        _createElementVNode("p", null, _toDisplayString(_ctx.$t("dashboardMessage2")), 1),
        _hoisted_6,
        _createElementVNode("p", null, _toDisplayString(_ctx.$t("dashboardMessage3")), 1),
        _createElementVNode("p", null, [
          _createElementVNode("a", {
            href: _ctx.$t('dashboardDocLink')
          }, _toDisplayString(_ctx.$t("voirDocument")), 9, _hoisted_7)
        ]),
        _hoisted_8
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listeDeLiens, (lien) => {
        return (_openBlock(), _createElementBlock("div", {
          key: lien.num
        }, [
          (lien.text.length > 0)
            ? (_openBlock(), _createElementBlock("h1", _hoisted_9, _toDisplayString(lien.text), 1))
            : _createCommentVNode("", true),
          (lien.items.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lien.items, (item) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: item.num
                  }, [
                    (item.type === 'info')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.$t(item.text)), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          (item.type != 'title')
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                class: "module",
                                id: item.id,
                                to: item.to
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("img", {
                                    style: {"max-height":"60px"},
                                    src: item.img.src,
                                    alt: item.img.alt
                                  }, null, 8, _hoisted_13),
                                  _createElementVNode("h2", null, _toDisplayString(item.text), 1)
                                ]),
                                _: 2
                              }, 1032, ["id", "to"]))
                            : _createCommentVNode("", true)
                        ]))
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}